import { render, staticRenderFns } from "./DropButton.vue?vue&type=template&id=1b3d0826"
import script from "./DropButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DropButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports